// extracted by mini-css-extract-plugin
export default {"btns":"View_btns__KYECU","button":"View_button__vGzWU","description":"View_description__MJLNG"};